import React, { useEffect, useState } from "react";
import AnimatedButton from "./AnimatedButton";

function CopyButton({
  onClick,
  copied = false,
  children,
  style = {},
  ...props
}) {
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (copied) {
      setShowSuccess(true);

      const timeout = setTimeout(() => {
        setShowSuccess(false);
      }, 1800);

      return () => clearTimeout(timeout);
    }
  }, [copied]);

  return (
    <AnimatedButton
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "10px",
        position: "relative",
        ...style
      }}
      onClick={onClick}
      {...props}
    >
      <span
        className={`hookora-copy-icon ${
          showSuccess
            ? "hookora-copy-success"
            : ""
        }`}
      >
        {showSuccess ? "✓" : "⧉"}
      </span>

      <span>
        {children}
      </span>
    </AnimatedButton>
  );
}

export default CopyButton;